<template>
  <zt-modal
    class="rounded font-normal"
    max-width="600px"
    :title="$t('message.workflow.table.seeDocument')"
    :active="active"
    :z-index="1001"
    @close="closeDialog"
  >
    <template>
      <div class="w-full" :style="documentMaxHeight">
        <div v-if="loadingDocumentInfo" class="w-full h-full relative">
          <div
            class="data-loader w-full h-full text-zt-primary-200 flex flex-column justify-center items-center pointer-events-none"
          >
            <div class="data-loader-circle" />
          </div>
        </div>
        <div v-else class="w-full h-full flex px-10 py-12">
          <zt-slider>
            <zt-slider-item
              v-for="(page, index) in documentPageList"
              @slide-active="getPage(page)"
              :key="index"
            >
              <div v-if="documentPageLoading" class="w-full h-full relative">
                <div
                  class="data-loader w-full h-full text-zt-primary-200 flex flex-column justify-center items-center pointer-events-none"
                >
                  <div class="data-loader-circle" />
                </div>
              </div>
              <workflow-document-preview v-else :img-url="documentPage" />
            </zt-slider-item>
          </zt-slider>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="zt-modal-footer rounded-b flex justify-end items-center p-4">
        <zt-button class="w-25" @click="closeDialog">
          {{ $t('message.workflow.modal.close') }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>

<script>
import { isEmpty } from 'lodash'
import { useWindowResize } from '@sichern/ui-elements'
import WorkflowDocumentPreview from '@/modules/Documents/Workflow/components/WorkflowDocumentPreview.vue'
import Employee from '@/apiClient/Employee'
export default {
  name: 'DocumentPreviewDialog',
  components: {
    WorkflowDocumentPreview
  },
  inject: ['setPreviewDialog'],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    workflowSelected: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      apiEmployee: new Employee(),
      loadingDocumentInfo: false,
      windowResize: useWindowResize(this),
      documentPageLoading: false,
      documentPage: '',
      documentPageList: []
    }
  },
  watch: {
    active() {
      if (!this.active) {
        this.documentPage = ''
        this.documentPageList = []
        this.documentPageLoading = false
        this.loadingDocumentInfo = false
      }
    },
    workflowSelected: {
      handler() {
        if (!isEmpty(this.workflowSelected)) {
          const documentPreviewList = this.getDocumentPreviewList()
          this.getDocumentUploaded(documentPreviewList)
        }
      },
      deep: true
    }
  },
  computed: {
    documentMaxHeight() {
      return {
        height: this.windowResize.width <= 1366 ? '374px' : '620px'
      }
    }
  },
  methods: {
    closeDialog() {
      if (this.loadingDocumentInfo || this.documentPageLoading) return
      this.setPreviewDialog(false)
    },
    async getTotalPages(collection) {
      const documentPagePreviewList = []
      for (const { id, doc, fs } of collection) {
        const {
          data: {
            results: { data: numbPages }
          }
        } = await (fs
          ? this.apiEmployee.getDocumentPagesFS(id, doc)
          : this.apiEmployee.getDocumentPages(id, doc))
        for (let i = 0; i < numbPages; i++) {
          const number = i + 1
          documentPagePreviewList.push({ id, doc, number, fs })
        }
      }
      return documentPagePreviewList
    },

    async getDocumentUploaded(uploadFiles) {
      this.loadingDocumentInfo = true
      this.documentPageList = []
      try {
        this.documentPageList = await this.getTotalPages(uploadFiles)
      } catch (e) {
        this.documentPageList = []
      } finally {
        this.loadingDocumentInfo = false
      }
    },

    async getPage(page) {
      this.documentPageLoading = true
      try {
        const { id, doc, number, fs } = page
        const documentPage = await (fs
          ? this.apiEmployee.getDocumentUploadedFS(id, doc, number)
          : this.apiEmployee.getDocumentUploaded(id, doc, number))
        this.documentPage = 'data:image/*;base64,' + documentPage
        this.documentPageLoading = false
      } catch (error) {
        this.documentPageLoading = false
        this.documentPage = ''
      }
    },

    getDocumentPreviewList() {
      const { show: pageList, document_id } = this.workflowSelected
      if (Array.isArray(pageList)) {
        return pageList.map(item => {
          return {
            id: document_id,
            doc: item.hash,
            fs: false
          }
        })
      }
      return [
        {
          id: pageList.idAppSICHERN,
          doc: pageList.iddoc,
          fs: true
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.data-loader {
  min-height: 15rem;
}
.data-loader .data-loader-circle {
  width: 50px;
  height: 50px;
  background: transparent;
  border: 5px solid;
  border-radius: 50%;
  border-bottom-color: transparent;
  animation: animate-loader 1.5s linear infinite;
}
@keyframes animate-loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.zt-modal-footer {
  background-color: #eeeeee;
}
::v-deep {
  .zt-slider .zt-slider-control > div {
    flex: none;
    &:nth-child(1) {
      opacity: 0;
      width: 0;
      height: 0;
      overflow: hidden;
    }
  }
}
</style>
